/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-11-17 15:58:59
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-17 17:46:10
 */
import req from "@/utils/request";
export const saveOrUpdateRobot = (params) => req.post("/interact-service/m/isRobotSet/saveOrUpdateRobot", params);
export const delDes = (params) => req.post("/interact-service/m/isRobotSet/siteId", params);
export const findListPage = (params) => req.post("/interact-service/m/isHotTheme/findHotThemeListPage", params);
export const updateDisplayStatus = (params) => req.post("/interact-service/m/isHotTheme/updateHotWhetherEnable", params);
export const collectDelete = (params) => req.post("/interact-service/m/isHotTheme/deleteQuestionHotTheme", params);
export const saveHotTheme = (params) => req.post("/interact-service/m/isHotTheme/saveHotTheme", params);
export const updateHotTheme = (params) => req.post("/interact-service/m/isHotTheme/updateHotTheme", params);
export const updateHotSort = (params) => req.post("/interact-service/m/isHotTheme/updateHotSort", params);